import { get, post, del, put } from '@api/request';
import { defaultPageSize } from '@constants';

export async function fetchSearchOptions(
  { appraisalService },
  authenticationToken,
) {
  const url = `${appraisalService}/appraisal/config/mortgagelendersearch`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function searchMortgagelender(
  { appraisalService },
  authenticationToken,
  {
    pageSize = defaultPageSize,
    page = 1,
    sortField,
    sortDirection,
    filterModel,
    searchOptions,
  },
) {
  let url = `${appraisalService}/appraisal/mortgagelender/search`;
  url += `?page=${page}&pageSize=${pageSize}`;
  if (sortField && sortDirection) {
    url += `&sortField=${sortField}&sortDirection=${sortDirection}`;
  }
  if (filterModel && Object.keys(filterModel).length >= 0) {
    Object.keys(filterModel).forEach(filter => {
      url += `&searchField=${filter}&searchText=${filterModel[filter].value}`;
    });
  }
  const { body } = await post(authenticationToken, url, searchOptions);
  return body;
}

export async function fetchFields({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/config/mortgagelendersearchresults`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchTags({ appraisalService }, authenticationToken) {
  const url = `${appraisalService}/appraisal/mortgagelender/tags`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMortgagelender(
  { appraisalService },
  authenticationToken,
  { mortgagelenderId },
) {
  const url = `${appraisalService}/appraisal/mortgagelender/${mortgagelenderId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMortgagelenderNotes(
  { appraisalService },
  authenticationToken,
  { mortgagelenderId },
) {
  const url = `${appraisalService}/appraisal/mortgagelender/${mortgagelenderId}/notes`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchMortgagelenderProperties(
  { appraisalService },
  authenticationToken,
  { mortgagelenderId },
) {
  const url = `${appraisalService}/appraisal/mortgagelender/${mortgagelenderId}/property`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteMortgagelenderNote(
  { appraisalService },
  authenticationToken,
  { noteId },
) {
  const url = `${appraisalService}/appraisal/mortgagelendernote/${noteId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateMortgagelenderNote(
  { appraisalService },
  authenticationToken,
  { noteId, data },
) {
  const url = `${appraisalService}/appraisal/mortgagelendernote/${noteId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function addMortgagelenderNote(
  { appraisalService },
  authenticationToken,
  { id, data },
) {
  const url = `${appraisalService}/appraisal/mortgagelender/${id}/notes`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function validateMortgagelender(
  { appraisalService },
  authenticationToken,
  { mortgagelenderId, data },
) {
  const url = `${appraisalService}/appraisal/mortgagelender/${mortgagelenderId}/casscertification`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updateMortgagelender(
  { appraisalService },
  authenticationToken,
  { mortgagelenderId, data },
) {
  const url = `${appraisalService}/appraisal/mortgagelender/${mortgagelenderId}`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function createMortgagelender(
  { appraisalService },
  authenticationToken,
  { data },
) {
  const url = `${appraisalService}/appraisal/mortgagelenders`;
  const { body } = await post(authenticationToken, url, data);
  return body;
}

export async function fetchLenderEvents(
  { eventService },
  authenticationToken,
  { mortgagelenderId },
) {
  const url = `${eventService}/events/search`;
  const { body } = await post(authenticationToken, url, {
    objectID: `${mortgagelenderId}`,
    dataObject: 'lender',
  });
  return body;
}

export async function fetchPropertyMortgageLenders(
  { appraisalService },
  authenticationToken,
  { pId, pYear, pRollCorr, pVersion },
) {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/mortgagelenders`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function getPropertyMortgageLender(
  { appraisalService },
  authenticationToken,
  { lenderId },
) {
  const url = `${appraisalService}/appraisal/propertymortgagelender/${lenderId}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deletePropertyMortgagelender(
  { appraisalService },
  authenticationToken,
  { lenderId },
) {
  const url = `${appraisalService}/appraisal/propertymortgagelender/${lenderId}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function insertProperyMortgageLender(
  { appraisalService },
  authenticationToken,
  { pId, pYear, pRollCorr, pVersion, payload },
) {
  const url = `${appraisalService}/appraisal/property/${pId}/${pYear}/${pVersion}/${pRollCorr}/mortgagelenders`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}
